import { useMemo, useState } from 'react'
import useSWR from 'swr'
import { Textlayout } from '../layout'
import ShopifyImage from 'components/shop/shopifyImage'
import Link from 'next/link'
import Button from 'components/ui/button'
import { createCart, getCart, addToCart } from 'lib/shop/cartCommon'

const fetcher = (...args) => fetch(...args).then((res) => res.json())

export default function ShopBlock({ shortcode }) {
  const attributes = useMemo(() => {
    let attributes = {}
    shortcode.match(/[\w-]+=".*?"/g).forEach(function (attribute) {
      attribute = attribute.match(/([\w-]+)="(.*?)"/)
      attributes[attribute[1]] = attribute[2]
    })
    return attributes
  }, [shortcode])

  if (
    !attributes.shopifyProductId ||
    !attributes.buttonType ||
    ['show_more', 'buy'].indexOf(attributes.buttonType) === -1
  ) {
    return <div>Error with shortcode attributes</div>
  }

  return (
    <div className="relative">
      <Inner attributes={attributes} />
    </div>
  )
}

const Inner = ({ attributes }) => {
  const productData = useSWR(`/api/shop/product?id=${attributes.shopifyProductId}`, fetcher)
  const [acceptTerms, setAcceptTerms] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  if (productData.error || !productData.data?.product) return null
  if (!productData.data) return <div className="flex justify-center">Chargement du produit...</div>

  const onBuyNow = ({ variantId }) => {
    if (!acceptTerms) {
      return alert('Vous devez accepter les conditions générales de vente et renoncer à vos droits de rétractation.')
    }

    setIsLoading(true)

    createCart({ variantId, quantity: 1 })
      .then((cart) => {
        setIsLoading(false)
        window.location.href = cart.checkoutUrl
      })
      .catch((error) => {
        console.error('An error occured while creating cart.', error)
        setIsLoading(false)
      })
  }

  return (
    <>
      <div
        className={`${
          attributes.title ? 'mt-12' : ''
        } relative z-10 grid grid-cols-1 gap-8 bg-orange p-6 text-white md:grid-cols-[2fr,3fr]`}>
        <ShopifyImage imageData={productData.data.product.featuredImage} />
        <div className="flex flex-col justify-between">
          <div>
            {productData.data.product.collections.edges.length > 0 ? (
              <Link href={`/shop/categorie/${productData.data.product.collections.edges[0].node.handle}`}>
                <a className="uppercase text-white/75 !no-underline">
                  {productData.data.product.collections.edges[0].node.title}
                </a>
              </Link>
            ) : null}
            <div className="font-serif text-2xl font-bold">{productData.data.product.title}</div>
            <div className="mt-1 text-sm">
              {parseFloat(productData.data.product.variants.edges[0].node.priceV2.amount).toLocaleString('fr-BE', {
                style: 'currency',
                currency: 'EUR'
              })}
            </div>
          </div>
          <div className="">
            {attributes.buttonType === 'buy' ? (
              <div className="mt-4 text-sm">
                <label htmlFor="cgv">
                  <input id="cgv" type="checkbox" className="" onChange={(e) => setAcceptTerms(e.target.checked)} />{' '}
                  J'ai lu et j'accepte les{' '}
                  <Link href="/cgv">
                    <a className="underline">conditions générales de vente</a>
                  </Link>{' '}
                  et renonce à mon droit de rétractation.
                </label>
              </div>
            ) : null}
            <div className="mt-2 flex space-x-4">
              <Button
                href={`/shop/product/${productData.data.product.handle}`}
                type="yellow-outline"
                isLoading={isLoading}>
                Voir plus
              </Button>
              {attributes.buttonType === 'buy' ? (
                <Button
                  onClick={(e) => {
                    onBuyNow({ variantId: productData.data.product.variants.edges[0].node.id })
                  }}
                  type="yellow"
                  isLoading={isLoading}>
                  Acheter
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {attributes.title ? (
        <div className="absolute -top-6 right-4 z-0 md:-top-8">
          <div className="font-serif text-4xl font-bold text-yellow opacity-50 md:text-5xl">{attributes.title}</div>
        </div>
      ) : null}
    </>
  )
}
